import { getEligibilityLabel } from '../../../../intl'
import { getCompany } from './getter/getCompany'

type ComputeOrderDataPayload = {
  order: uui.domain.client.rm.ExtendedOrderStep
  companiesMap: Record<string, uui.domain.client.rm.Company>
  archived: boolean
  formatEligibility: (eligibility: uui.domain.client.rm.Eligibility) => string
}

export type OrderData = ReturnType<typeof computeOrderData>

export function computeOrderData(payload: ComputeOrderDataPayload) {
  const { order, companiesMap, archived, formatEligibility } = payload
  const {
    order: { eligibility, loads, priority, forceVehicleId },
    orderStep: { serviceTimeSec, phone, email, notes, tagsIn = [], tagsOut = [], timeWindows = [] },
  } = order

  const company = getCompany(order, companiesMap, archived)

  const violations = order.isUnassigned ? [] : (order.violations ?? [])

  const formattedEligibility = formatEligibility(eligibility)
  const eligibilityText = getEligibilityLabel(eligibility, formattedEligibility)

  return {
    company,
    eligibility: eligibilityText,
    loads,
    priority,
    serviceTime: serviceTimeSec,
    vehicleId: forceVehicleId ?? '',
    phone: phone ?? '',
    email: email ?? '',
    notes: notes ?? '',
    tagsIn,
    tagsOut,
    violations,
    timeWindows,
  }
}
